import { createSelector } from 'reselect';
import _forEach from 'lodash/forEach';

import { colors } from '../Construction/utils/convertCalculationResponse';

const constructionSelector = (state) => state.Construction;

// ✅ nowe klucze kolorów bram per typ (Twoje nazewnictwo)
const GATE_COLOR_KEYS = [
  'gates_swing_color',
  'gates_double_leaf_color',
  'gates_sectional_color',
  'gates_roller_color',
];

// ✅ pełna lista kluczy kolorów jakie chcemy wystawić do 3D/tekstur
const ALL_COLOR_KEYS = Array.from(new Set([...(colors || []), ...GATE_COLOR_KEYS]));

export default createSelector(
  constructionSelector,
  (construction) => {
    const currentWidth = construction.available?.width?.find(
      (el) => el.id === construction.selected?.width
    );
    const currentLength = construction.available?.length?.find(
      (el) => el.id === construction.selected?.length
    );

    let currentHeight;

    const firstHeight = construction.available?.first_height?.find(
      (el) => el.id === construction.selected?.first_height
    );

    const secondHeight = construction.available?.second_height?.find(
      (el) => el.id === construction.selected?.second_height
    );

    const pressing = construction.available?.pressing?.find(
      (el) => el.id === construction.selected?.pressing
    );

    const gates_pressing = construction.available?.gates_pressing?.find(
      (el) => el.id === construction.selected?.gates_pressing
    );

    const firstGate = construction.available?.gate_rear_left_width?.find(
      (el) => el.id === construction.selected?.gate_rear_left_width
    );

    const secondGate = construction.available?.gate_left_width?.find(
      (el) => el.id === construction.selected?.gate_left_width
    );

    const thirdGate = construction.available?.gate_right_width?.find(
      (el) => el.id === construction.selected?.gate_right_width
    );

    const fourthGate = construction.available?.gate_rear_right_width?.find(
      (el) => el.id === construction.selected?.gate_rear_right_width
    );

    const gate_rear_left_space = construction.available?.gate_rear_left_space?.[0]?.attributes?.value || 0;
    const gate_left_space = construction.available?.gate_left_space?.[0]?.attributes?.value || 0;
    const gate_right_space = construction.available?.gate_center_space?.[0]?.attributes?.value || 0;
    const gate_rear_right_space = construction.available?.gate_rear_right_space?.[0]?.attributes?.value || 0;

    const gate_rear_left = construction.available?.gate_rear_left?.find(
      (el) => el.id === construction.selected?.gate_rear_left
    );

    const gate_left = construction.available?.gate_left?.find(
      (el) => el.id === construction.selected?.gate_left
    );

    const gate_right = construction.available?.gate_right?.find(
      (el) => el.id === construction.selected?.gate_right
    );

    const gate_rear_right = construction.available?.gate_rear_right?.find(
      (el) => el.id === construction.selected?.gate_rear_right
    );

    // Defensive attribute assignment
    if (firstGate && gate_rear_left) {
      firstGate.attributes.isVertical = gate_rear_left.attributes.gate === 'vertical_gate';
      firstGate.attributes.name = 'first_gate';
      firstGate.attributes.totalSpace = gate_rear_left_space;
    }

    if (secondGate && gate_left && firstGate?.attributes) {
      secondGate.attributes.isVertical = gate_left.attributes.gate === 'vertical_gate';
      secondGate.attributes.name = 'second_gate';
      secondGate.attributes.totalSpace = (firstGate.attributes.totalSpace || 0) + gate_left_space;
    }

    if (thirdGate && gate_right && secondGate?.attributes) {
      thirdGate.attributes.isVertical = gate_right.attributes.gate === 'vertical_gate';
      thirdGate.attributes.name = 'third_gate';
      thirdGate.attributes.totalSpace = (secondGate.attributes.totalSpace || 0) + gate_right_space;
    }

    if (fourthGate && gate_rear_right && thirdGate?.attributes) {
      fourthGate.attributes.isVertical = gate_rear_right.attributes.gate === 'vertical_gate';
      fourthGate.attributes.name = 'fourth_gate';
      fourthGate.attributes.totalSpace = (thirdGate.attributes.totalSpace || 0) + gate_rear_right_space;
    }

    const isTile = construction.selected?.inside === 2;
    const isTooling = construction.selected?.tooling === 2;
    // ✅ zbuduj lookup po ID -> kolor z doklejonym type (matt/smooth/wooden)
    const colorById = {};
    const addList = (arr, type) => {
      (arr || []).forEach((c) => {
        colorById[c.id] = { ...c, type };
      });
    };

    addList(construction.available?.matt, 'matt');
    addList(construction.available?.smooth, 'smooth');
    addList(construction.available?.wooden, 'wooden');

    // fallback: jeśli coś jest tylko w available.colors
    (construction.available?.colors || []).forEach((c) => {
      if (!colorById[c.id]) {
        colorById[c.id] = {
          ...c,
          type: c.type || c.attributes?.type || 'matt',
          hexa: c.hexa || c.attributes?.hexa,
          preview_url: c.preview_url || c.attributes?.preview_url,
        };
      }
    });

    // ✅ zbuduj colorsData pod wszystkie klucze, w tym bramy per typ
    const colorsData = {};
    _forEach(ALL_COLOR_KEYS, (key) => {
      const selectedId = construction.selected?.[key];
      if (selectedId === null || selectedId === undefined) return;

      const selectedColor = colorById[selectedId];
      if (selectedColor) {
        colorsData[key] = selectedColor;
      }
    });

    if (construction.activeConstruction == 1) {
      currentHeight = firstHeight;
    } else if (construction.activeConstruction == 2) {
      currentHeight = secondHeight;
    } else if (construction.activeConstruction == 3) {
      currentHeight = secondHeight;
    } else if (construction.activeConstruction == 4) {
      currentHeight = secondHeight;
    } else if (construction.activeConstruction == 5) {
      currentHeight = firstHeight;
    } else if (construction.activeConstruction == 6) {
      currentHeight = secondHeight;
    }
    console.log(construction);
    return {
      width: currentWidth?.attributes?.value_cm,
      length: currentLength?.attributes?.value_cm,
      height: currentHeight?.attributes?.value_cm,
      first_height: firstHeight?.attributes?.value_cm,
      second_height: secondHeight?.attributes?.value_cm,
      activeConstruction: construction.activeConstruction,
      constructionsLoaded: construction.constructionsLoaded,
      pressing: pressing?.id,
      gates_pressing: gates_pressing?.id,
      colors: colorsData,

      firstGate: firstGate?.attributes || null,
      secondGate: secondGate?.attributes || null,
      thirdGate: thirdGate?.attributes || null,
      fourthGate: fourthGate?.attributes || null,

      isTile,
      isTooling,
      anchoring: construction.selected?.anchoring || null,
      moisture_protection: construction.selected?.moisture_protection || null,
      structure: construction.selected?.structure || null,
    };
  }
);
